import { ExDynamicService, DocumentWrapper, WindowWrapper } from './dynamic.service'

export {
  ExDynamicService,
  DocumentWrapper,
  WindowWrapper,
}
